export const OpDefalutQueryStore = {
  storeName: "驾捷乐实业（上海）有限公司",
  storeCode: "S00210319LS",
  label: "驾捷乐实业（上海）有限公司",
  value: "S00210319LS"
};
